///////////////////////////
// CurrentUser.js /////////
///////////////////////////

var Cookies = require("js-cookie");
var Features = require("lib/account/Features");

// For legacy access
var WhooosReadingClientApi = require("wr_apis/apis/wr_client_api/node_package/src/index.js")

// For the new client access used by redux
var APIClient = require("lib/web/APIClient");
var CustomersAPIClient = require("lib/web/CustomersAPIClient");

var CustomerIOClient = require("lib/integrations/CustomerIOClient");
// var NewRelicClient = require("lib/integrations/NewRelicClient");
// var LuckyOrangeClient = require("lib/integrations/LuckyOrangeClient");
var LiveChatClient = require("lib/integrations/LiveChatClient");
var SentryClient = require("lib/integrations/SentryClient");

var GradeLevel = require("lib/academic/GradeLevel");
var AccountPlans = require("lib/account/AccountPlans");
var WhooosReadingServices = require('lib/web/WhooosReadingServices');
var moment = require("moment");

var CurrentUser = {
	get: function() {
		if (this.isLoaded()) {
			return window.wr_currentUserData.userData;
		} else if (this.isPassphraseUser()) {
			return window.wr_currentUserData.passphraseUserData;
		}
	},

	updateLocal: function(updatedUserData) {
		window.wr_currentUserData.userData = _.extend(
			window.wr_currentUserData.userData, updatedUserData
		);
	},

	getLevel: function() {
		if (this.isLoaded()) {
			return GradeLevel.getQuizLevel(this.get().prefs.academic_level);
		}
	},

	paymentMethodSummary() {
		var cardInfo = this.get().account.card_info;
		if (!cardInfo) {
			return "No payment method information";
		}

		var text = cardInfo.brand + " **" + cardInfo.last4;
		if (cardInfo.exp_year && cardInfo.exp_month) {
			text += " expires " + cardInfo.exp_month + "/" + cardInfo.exp_year.toString().slice(-2);
		}
		return text;
	},

	// Gets api with the current users's authentication already loaded in
	api: function() {
		if (this.isSignedIn() || this.isPassphraseUser()) {
			if (window.wr_currentUserData.api == undefined) {

				window.wr_currentUserData.api = new WhooosReadingClientApi.LegacyClient();

				if (this.isSignedIn()) {
					// Auth for legacy client
					window.wr_currentUserData.api.addAuth(window.wr_currentUserData.userToken);

					// Adds auth to the new client used by redux
					APIClient.addAuth(window.wr_currentUserData.userToken)
					CustomersAPIClient.addAuth(window.wr_currentUserData.userToken)
				} else {
					window.wr_currentUserData.api.addAuth($wr.getURLParameterByName("passphrase"));
				}
			}
			return window.wr_currentUserData.api;
		}
	},

	// setWizardApi: function() {
	// 	if (window.wr_currentUserData.api == undefined) {
	// 		window.wr_currentUserData.api = new WhooosReadingClientApi.LegacyClient();
	// 	}
	// },

	getToken: function() {
		return window.wr_currentUserData.userToken
	},

	fetchCurrentUserData: function(callback, alternateEmbeds) {
		var defaultEmbeds = "user.settings,user.user_alerts,user.email,split_tests";
		defaultEmbeds += ",user.source_data,user.pending_task,user.pending_notification_count";
		defaultEmbeds += ",user.school";
		defaultEmbeds += ",user.sso_data,admin.expectations_date_spans,admin.completed_quiz_count,student.account_overdrawn";
		defaultEmbeds += ",user.prefs,admin.student_list_ids";

		if (window.wr_currentUserData.userType == "Student") {
			defaultEmbeds += ",student.account,student.coin_records";
			defaultEmbeds += ",student.avatar,student.perks,student.current_reading_level";
			defaultEmbeds += ",student.primary_student_list,student_list.primary_admin"
		} else if (window.wr_currentUserData.userType == "Admin") {
			defaultEmbeds += ",admin.account,user.org_prefs,admin.primary_school_org_id,admin.primary_district_org_id";
		} else {
			defaultEmbeds += ",user.account,wizard.crm_config";			
		}

		if (this.isSignedIn()) {
			var embeds = alternateEmbeds == undefined ? defaultEmbeds : alternateEmbeds;

			var params = { embed: embeds };


			this.api().getUser(window.wr_currentUserData.userID, params, function(response, success, errorCode, jqXHR) {

				if (response && response.user && response.user.site_maintenance) {
					$wr.redirect("/maintenance");
					callback(false);
					return;
				}

				const userID = window.wr_currentUserData.userID;

				if (success && response.user.id == window.wr_currentUserData.userID) {
					if (window.wr_currentUserData.userData == undefined) {
						window.wr_currentUserData.userData = response.user;
					} else {
						window.wr_currentUserData.userData = _.extend(
							window.wr_currentUserData.userData, response.user);
					}
					window.wr_currentUserData.fullyLoaded = window.wr_currentUserData.fullyLoaded ||
						(embeds == defaultEmbeds);


					//////////////////
					// Handle special cases depending on what data was requested
					//////////////////

					// Displays any new user notices
					if (response.user.user_alerts && response.user.user_alerts.length > 0) {
						const coinDelay = 1200;
						response.user.user_alerts.map(function(alert, i){
							if (alert.type == this.WP_AWARD && alert.title != "0") {
								setTimeout(function() {
									if (window.wrNotifications && window.wrNotifications.triggerCoinAward) {
										window.wrNotifications.triggerCoinAward();
									}
								}, (coinDelay * i));
							} else if (alert.type == this.SITE_MESSAGE || alert.type == this.TEACHER_MESSAGE) {
								setTimeout(function() {
									if (window.wrNotifications == undefined) {
										window.wrNotifications = {};
									}

									var allowFormatting = alert.type == this.SITE_MESSAGE;
									
									if (window.wrNotifications.triggerModalNotification) {
										window.wrNotifications.triggerModalNotification(alert, allowFormatting);
									} else {
										window.wrNotifications.pendingModalNotifications = [[alert, allowFormatting]];
									}
								}.bind(this), 100);
							} else if (alert.type == this.CALENDLY_PROMPT) {
								setTimeout(function() {
									if (window.wrNotifications == undefined) {
										window.wrNotifications = {};
									}
									if (window.wrNotifications.triggerCalendlyModal) {
										window.wrNotifications.triggerCalendlyModal(alert);
									} else {
										window.wrNotifications.pendingCalendlyModal = [alert];
									}
								}.bind(this), 100);
							}
						}.bind(this))
					}

					// Sets a pending task notice, if one is present
					if (response.user.pending_task && response.user.pending_task.length > 0) {
						// delay, so the notification container to load in
						setTimeout(function() {
							if (window.wrNotifications) {
								window.wrNotifications.loadPendingTask(response.user.pending_task);
							}
						}, 100);
					}

					// Sets/updates this user's analytics tracking info
					if (response.user.split_tests) {
						var mycroftUserData = this.get();

						Mycroft.setUserData(mycroftUserData, response.user.split_tests);
					}

					CustomerIOClient.identify(response.user);
					// NewRelicClient.identify(response.user);

					SentryClient.setUserContext(response.user);

					// if (response.user.is_admin) {
					// 	FacebookPixelClient.init();
					// }

					// // Adds ZD Chat to all of teacher/admin acounts
					// if (response.user.is_admin) {
						// LiveChatClient.init(response.user);
					// }

					if (response.user.is_wizard && !$wr.isAppdev()) {
						window.location = WhooosReadingServices.Cheshire.url("/");
					}

					// var createdAt = moment().format(response.user.created_at);
					// var createdAtCutoff = moment().subtract(1, "hours").format();
					// if ((response.user.role == "teacherRole") && (createdAt > createdAtCutoff)) {
					// 	LuckyOrangeClient.init();
					// }

					// Alert any components that need to update when the current user is updated
					$(document).trigger("current-user-updated");

					if (callback) {
						callback(true);
					}

				} else if ((errorCode == 401) || (errorCode == 404) || (response && response.user && (response.user.id != userID))) {
					// Our token has expired or cookies got scrambled...
					this.logOut();
					this.init(callback);

				} else if (response == undefined) {
					window.wr_allowErrorPage = true;
					$wr.redirect("/error?which=authentication&redirect_refresh=true");
					if (callback) { callback(false); }
					console.error("No response to CurrentUser Authentication (L2E may be down)");
				} else {
					throw "Unknown error on CurrentUser Authentication: " + jqXHR.statusText;
				}
			}.bind(this));

		} else if (callback) {
			callback(false);
		}
	},

	fetchCurrentUserCoinData: function(callback) {
		CurrentUser.fetchCurrentUserData(callback, "student.coin_records,user.user_alerts");
	},

	fetchCurrentUserReferrals: function(callback) {
		CurrentUser.fetchCurrentUserData(callback, "admin.referred_by,admin.referred_count");
	},

	hasID: function(id) {
		return this.get() && this.get().id == id;
	},

	fetchSchoolYearDates() {
		var dateInfo = {startDate: "", endDate: "", numMonths: 0}
		
		var currentYear = $wr.momentInTimezone(new Date()).year();
		// months must be and index between 0 - 11
		var currentMonth = $wr.momentInTimezone(new Date()).month();
		var startMonth = CurrentUser.get().prefs.school_year_start_month; 
		if (currentMonth >= startMonth) {
			// we're in the same calendar year as the school year start
			dateInfo.startDate = (new Date(currentYear, startMonth, 1)).getTime();
			dateInfo.numMonths = currentMonth - startMonth;
		} else {
			// we're in the next calendar year
			dateInfo.startDate = (new Date(currentYear - 1, startMonth, 1)).getTime();
			dateInfo.numMonths = (11 - startMonth) + currentMonth;
		}

		dateInfo.endDate = $wr.momentInTimezone((new Date(currentYear, currentMonth+1, 1))).endOf('month')
		return dateInfo;
	},

	isStudent: function() {
		return this.isLoaded() && this.get().is_student;
	},
	isAdmin: function() {
		return this.isLoaded() && this.get().is_admin;
	},
	isTeacherAdmin: function() {
		return this.isAdmin() && this.get().role == "teacherRole";
	},
	isSchoolAdmin: function() {
		return this.isAdmin() && this.get().role == "adminRole";
	},
	isDistrictAdmin: function() {
		return this.isAdmin() && this.get().role == "districtAdminRole";
	},
	isSponsor: function() {
		return this.isLoaded() && this.get().is_sponsor;
	},
	isWizard: function() {
		return this.isLoaded() && this.get().is_wizard;
	},

	isDemo: function() {
		return this.isLoaded() && this.get().demo;
	},

	isPassphraseUser: function() {
		return this.isInitialized() && (window.wr_currentUserData.passphrase != undefined);
	},
	isPendingSSOUser: function() {
		return this.isLoaded() && this.get().sso_data && this.get().sso_data.pending;
	},
	isSSOUser: function() {
		return this.isGoogleSSOUser() || this.isCleverSSOUser();
	},
	isGoogleSSOUser: function() {
		return this.isLoaded() && this.get().sso_data && this.get().sso_data.google;
	},
	isCleverSSOUser: function() {
		return this.isLoaded() && this.get().sso_data && this.get().sso_data.clever;
	},

	isLoaded: function() {
		return this.isSignedIn() && window.wr_currentUserData.userData &&
			window.wr_currentUserData.fullyLoaded;
	},
	isSignedIn: function() {
		return this.isInitialized() && window.wr_currentUserData.userID;
	},
	isInitialized: function() {
		return window.wr_currentUserData != undefined;
	},

	isOverdrawnUser: function() {
		return this.isLoaded() && this.get().account_overdrawn;
	},

	isPremiumAccount: function () {
		return this.isLoaded() &&
			(this.get().product == AccountPlans.PRODUCTS.WR_GOLD ||
				this.get().product === AccountPlans.PRODUCTS.WR_SILVER ||
				this.get().account.silver_features ||
				this.get().account.gold_features);
	},

	isPayingUser: function () {
		return this.get().account.paying
	},

	isPremiumOrTrialAccount: function () {
		var activeTrials = this.get().account.active_trials
		var inATrial = Object.keys(activeTrials).length !== 0
		return inATrial || this.isPremiumAccount()
	},

	usernamePasswordAuthenticate: function(username, password, callback) {
		var client = new WhooosReadingClientApi.LegacyClient();
		var credentials = { username: username, password: password };
		client.postAccessTokens({ credentials: credentials }, function(response, success, error) {
			if (success) {
				this.setUserCredentials(response["user_id"], response["token"], response["user_type"], callback);

			} else if (response) {
				callback(false, response["message"]);
			} else {
				callback(false, "Unknown Error");
			}
		}.bind(this));
	},

	setUserCredentials: function(userID, token, userType, callback) {
		const domain = this.getCookieDomain();

		Cookies.set(this.USER_ID_KEY, userID, { expires: 10000, domain: domain });
		Cookies.set(this.USER_TYPE_KEY, userType, { expires: 10000, domain: domain });
		Cookies.set(this.USER_TOKEN_KEY, token, { expires: 10000, domain: domain });

		this.init(callback);
	},

	logOut: function() {
		const domain = this.getCookieDomain();

		Cookies.remove(this.USER_ID_KEY, { domain: domain });
		Cookies.remove(this.USER_TYPE_KEY, { domain: domain });
		Cookies.remove(this.USER_TOKEN_KEY, { domain: domain });

		window.wr_currentUserData = {};
	},

	getCookieDomain: function() {
		var hostParts = window.location.host.split(".");
		if (hostParts.length == 1) {
			// localhost domain should be ""
			return "";
		} else {
			var domain = hostParts.slice(hostParts.length - 2).join(".");
		}

		return domain;
	},

	// Callback should be a function that takes one boolean argument:
	//    true iff user is logged on and could be authenticated
	init: function(callback) {
		if ($wr.getURLParameterByName("passphrase")) {
			this.initPassphraseUser(callback);
			return;
		} 

		window.wr_currentUserData = {};
		const domain = this.getCookieDomain();

		// Don't change these con
		const userID = Cookies.get(this.USER_ID_KEY, { domain: domain });
		const userType = Cookies.get(this.USER_TYPE_KEY, { domain: domain });
		const userToken = Cookies.get(this.USER_TOKEN_KEY, { domain: domain });

		if (userID && userToken && parseInt(userID).toString() == userID) {
			window.wr_currentUserData.userID = userID;
			window.wr_currentUserData.userType = userType;
			window.wr_currentUserData.userToken = userToken;

			this.fetchCurrentUserData(callback);

		} else if (callback) {
			callback(false);
		}
	},

	initPassphraseUser: function(callback) {
		var passphrase = $wr.getURLParameterByName("passphrase");
		window.wr_currentUserData = { passphrase: passphrase };

		var embeds = "student_list.primary_admin"
		this.api().getStudentList(passphrase, { embeds: embeds }, function(response, success, errorCode, jqXHR) {
			window.wr_currentUserData.fullyLoaded = true;
			window.wr_currentUserData.passphraseUserData = { passphrase: passphrase, student_list: response.student_list }
			if (success) {
				if (callback) {
					callback(true);
				}
			} else {
				window.wr_currentUserData = {};
				if (callback) {
					callback(false);
				}
			}
		}.bind(this));

	},

	// Callback should be a function that takes one boolean argument:
	//    true iff user is logged on and could be authenticated
	initTokenUser: function(userID, userToken, callback) {
		window.wr_currentUserData = {};
		const domain = this.getCookieDomain();

		if (userID && userToken && parseInt(userID).toString() == userID) {
			window.wr_currentUserData.userID = userID;
			window.wr_currentUserData.userToken = userToken;

			this.fetchCurrentUserData(callback);

		} else if (callback) {
			callback(false);
		}
	},

	// Don't change these!
	USER_ID_KEY: "wr_currentUserID",
	USER_TYPE_KEY: "wr_currentUserType",
	USER_TOKEN_KEY: "wr_currentUserToken",
	WP_AWARD: "WpAward",
	SITE_MESSAGE: "SiteMessage",
	TEACHER_MESSAGE: "TeacherMessage",
	CALENDLY_PROMPT: "CalendlyPrompt"
}
module.exports = CurrentUser;



// WEBPACK FOOTER //
// ./modules/lib/account/CurrentUser.js